module.exports = __webpack_public_path__ + "img/cake-20.0c562a64.svg";